import { useNavigate } from 'react-router-dom';
import { CheckSquare, FileSignature, Mail, MessagesSquare, Plus, UserPlus } from 'lucide-react';
import { Button } from '../ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../ui/dropdown-menu';

// Only entries that open an existing flow.
const ITEMS = [
  { label: 'New Client', href: '/new-clients/new', icon: UserPlus, id: 'client' },
  { label: 'New Task', href: '/tasks?new=1', icon: CheckSquare, id: 'task' },
  { label: 'New Email / Message', href: '/comms/inbox?new=1', icon: MessagesSquare, id: 'message' },
  { label: 'New Letter', href: '/letters/new', icon: Mail, id: 'letter', featureKey: 'accountant_letters' },
  { label: 'Create Engagement', href: '/client-engagements', icon: FileSignature, id: 'engagement' },
];

export const NewMenu = ({ enabledFeatures = {} }) => {
  const navigate = useNavigate();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="sm" className="h-8 gap-1.5 px-3" data-testid="new-menu-btn"><Plus className="h-4 w-4" /><span className="hidden sm:inline">New</span></Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        {ITEMS.filter((i) => !i.featureKey || enabledFeatures[i.featureKey] !== false).map((i) => (
          <DropdownMenuItem key={i.id} onClick={() => navigate(i.href)} data-testid={`new-menu-${i.id}`}><i.icon className="mr-2 h-4 w-4 text-muted-foreground" />{i.label}</DropdownMenuItem>))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
